import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FaGithub, FaEnvelope, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "../component css/Footer.css";
import logo from "../assets/images/navbar/logo.svg";

function Footer() {
  const navigate  = useNavigate();
  const location  = useLocation();

  const goTo = (e, path) => {
    e.preventDefault();
    if (location.pathname === path) {
      // Already on this page — just scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    // Navigating away — kill hero pin then route
    ScrollTrigger.getAll().forEach((t) => { if (t.pin) t.kill(); });
    document.body.classList.remove("hero-pinned");
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-left">
          <a href="/" className="footer-logo" onClick={(e) => goTo(e, "/")}>
            <img src={logo} alt="Logo" width="138" height="236" />
          </a>

          <nav className="footer-nav">
            <a href="/" onClick={(e) => goTo(e, "/")}>Home</a>
            <a href="/projects" onClick={(e) => goTo(e, "/projects")}>Projects</a>
            <a href="/about"    onClick={(e) => goTo(e, "/about")}>About</a>
            <a href="/contact"  onClick={(e) => goTo(e, "/contact")}>Contact</a>
          </nav>
        </div>

        <div className="footer-socials">
          <a href="https://github.com/vaibhavkapoor7" target="_blank" rel="noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="/contact" onClick={(e) => goTo(e, "/contact")} aria-label="Contact">
            <FaEnvelope />
          </a>
          <a href="https://www.instagram.com/vaibhavkapoor___3?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.linkedin.com/in/vaibhav-kapoor-3-4-2006-vk" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 Vaibhav Kapoor. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;